type IconProps = {
  name:
    | "arrow-left"
    | "arrow-right"
    | "close"
    | "exit"
    | "garage"
    | "horn"
    | "info"
    | "lights"
    | "lock"
    | "more"
    | "reaction"
    | "share"
    | "sound"
    | "muted";
};

export function Icon({ name }: IconProps) {
  const paths: Record<IconProps["name"], React.ReactNode> = {
    "arrow-left": <path d="m15 18-6-6 6-6M9 12h11" />,
    "arrow-right": <path d="m9 6 6 6-6 6m6-6H4" />,
    close: <path d="m6 6 12 12M18 6 6 18" />,
    exit: (
      <>
        <path d="M10 5H5v14h5m4-4 4-3-4-3m4 3H9" />
      </>
    ),
    garage: (
      <>
        <path d="M3 10 5 5h14l2 5v9H3z" />
        <path d="M7 14h10M7 18h10M7 10h10" />
      </>
    ),
    horn: (
      <>
        <path d="M4 10h4l7-5v14l-7-5H4z" />
        <path d="M18 9c1 2 1 4 0 6m2-8c2 3 2 7 0 10" />
      </>
    ),
    info: (
      <>
        <circle cx="12" cy="12" r="9" />
        <path d="M12 11v6m0-10v.1" />
      </>
    ),
    lights: (
      <>
        <path d="M8 7c-3 0-5 2-5 5s2 5 5 5c3-3 3-7 0-10Z" />
        <path d="m13 8 7-3m-7 7h8m-8 4 7 3" />
      </>
    ),
    lock: (
      <>
        <rect x="5" y="10" width="14" height="10" rx="2" />
        <path d="M8 10V7a4 4 0 0 1 8 0v3" />
      </>
    ),
    more: (
      <>
        <circle cx="5" cy="12" r="1.5" />
        <circle cx="12" cy="12" r="1.5" />
        <circle cx="19" cy="12" r="1.5" />
      </>
    ),
    reaction: (
      <>
        <path d="M4 5h16v12H9l-5 3z" />
        <path d="M8 11h.1m3.9 0h.1m3.9 0h.1" />
      </>
    ),
    share: (
      <>
        <circle cx="18" cy="5" r="2.5" />
        <circle cx="6" cy="12" r="2.5" />
        <circle cx="18" cy="19" r="2.5" />
        <path d="m8.3 10.8 7.4-4.5m-7.4 6.9 7.4 4.5" />
      </>
    ),
    sound: (
      <>
        <path d="M4 10h4l5-4v12l-5-4H4z" />
        <path d="M16 9c2 2 2 4 0 6m3-9c4 4 4 8 0 12" />
      </>
    ),
    muted: (
      <>
        <path d="M4 10h4l5-4v12l-5-4H4z" />
        <path d="m17 10 4 4m0-4-4 4" />
      </>
    ),
  };

  return (
    <svg
      aria-hidden="true"
      className="icon"
      fill="none"
      viewBox="0 0 24 24"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1.8"
    >
      {paths[name]}
    </svg>
  );
}
